import styled from 'styled-components';

import BaseRadio from '@r1-frontend/ui-react/components/controls/baseRadio';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const PricesWrapper = styled.div`
    width: 100%;
    flex-direction: column;
    row-gap: 8px;
`;

export const PriceRow = styled.div`
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    background-color: ${COLORS.BgSurface};
    border-radius: ${BorderRadius.InnerBlockRadius};
`;

export const SBaseRadio = styled(BaseRadio)`
    width: 100%;

    input[type='radio'] {
        align-self: unset;
    }
`;

export const InnerContent = styled.div`
    width: 100%;
    justify-content: space-between;
    align-items: center;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const PriceValue = styled.span`
    display: inline-block;
`;

export const PriceDescription = styled.p`
    ${FONTS.XS};
    color: ${COLORS.TextInfo};
`;
